var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"action-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('span',{staticClass:"arrow-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }